import { RefObject, useRef } from 'react'

export const useScrollDelta = (
  scrollableContainerRef: RefObject<HTMLDivElement | null>
) => {
  const initialScrollLeftRef = useRef(0)

  const getScrollDelta = () => {
    // Calculate scroll delta
    if (scrollableContainerRef?.current) {
      const currentScrollLeft = scrollableContainerRef.current.scrollLeft
      return currentScrollLeft - initialScrollLeftRef.current
    }

    return 0
  }

  const onDragStart = () => {
    if (scrollableContainerRef?.current) {
      initialScrollLeftRef.current = scrollableContainerRef.current.scrollLeft
    }
  }

  return { getScrollDelta, onDragStart }
}
